export type DeployClickIntent = "openDeploy" | "requireLogin";

export function getDeployClickIntent({
    activeSession
}: {
    activeSession: boolean;
}): DeployClickIntent {
    return activeSession ? "openDeploy" : "requireLogin";
}
